export const seeker = "myplace/seeker";
export const giver = "myplace/giver";

export const seekerRoutes = {
  // branch = shubham
  getPersonalisation: `${process.env.PUBLIC_URL}/${seeker}/personalisation`,
  getPersonalise: `${process.env.PUBLIC_URL}/${seeker}/personalise`,
  getMyHappinessIndex: `${process.env.PUBLIC_URL}/${seeker}/my-happiness-index`,
  getAssessments: `${process.env.PUBLIC_URL}/${seeker}/assessments`,
  getHanieRoom: `${process.env.PUBLIC_URL}/${seeker}/hanie-room`,
  findAnExpert: `${process.env.PUBLIC_URL}/${seeker}/find-an-expert`,
  becomeaGiver: `${process.env.PUBLIC_URL}/${seeker}/become-a-giver`,
  getCommunity: `${process.env.PUBLIC_URL}/${seeker}/community`,
  becomeAnEvangelist: `${process.env.PUBLIC_URL}/${seeker}/become-an-evangelist`,
  getSeekerFeedback: `${process.env.PUBLIC_URL}/${seeker}/seeker-feedback`,

  getCoaching: `${process.env.PUBLIC_URL}/${seeker}/coaching`,
  getCoachingDetail: `${process.env.PUBLIC_URL}/${seeker}/coaching/:packageId`,
  createCoachingDetail: (id) =>
    `${process.env.PUBLIC_URL}/${seeker}/coaching/${id}`,
  getWorkshopDetail: `${process.env.PUBLIC_URL}/${seeker}/workshop/:packageId`,
  createWorkshopDetail: (id) =>
    `${process.env.PUBLIC_URL}/${seeker}/workshop/${id}`,
  getMyIkigai: `${process.env.PUBLIC_URL}/${seeker}/my-ikigai`,
  getJoinOurClub: `${process.env.PUBLIC_URL}/${seeker}/join-our-club`,
  getComingSoon: `${process.env.PUBLIC_URL}/${seeker}/coming-soon`,
  getOneToOne: `${process.env.PUBLIC_URL}/${seeker}/one-on-one`,
  getWorkShop: `${process.env.PUBLIC_URL}/${seeker}/workshop`,
  getInspiration: `${process.env.PUBLIC_URL}/${seeker}/inspiration`,
  getProgress: `${process.env.PUBLIC_URL}/${seeker}/progress`,
  getMyReports: `${process.env.PUBLIC_URL}/${seeker}/my-reports`,
  getTransaction: `${process.env.PUBLIC_URL}/${seeker}/transaction`,
  getResource: `${process.env.PUBLIC_URL}/${seeker}/resources`,
  getReferal: `${process.env.PUBLIC_URL}/${seeker}/referal`,
  getProfile: `${process.env.PUBLIC_URL}/${seeker}/profile`,
  getEcoSystem: `${process.env.PUBLIC_URL}/${seeker}/ecosystem`,
  getModuleRoute: `${process.env.PUBLIC_URL}/${seeker}/self-learning`,
  getLearningModule: `${process.env.PUBLIC_URL}/${seeker}/learning-modules`,
  getLeadershipModule: `${process.env.PUBLIC_URL}/${seeker}/leadership`,
  getStressMgmt: `${process.env.PUBLIC_URL}/${seeker}/stress-mgmt`,
  getEmotionalEating: `${process.env.PUBLIC_URL}/${seeker}/emotional-eating`,
  getNetworking: `${process.env.PUBLIC_URL}/${seeker}/networking`,
  getBodyShame: `${process.env.PUBLIC_URL}/${seeker}/bodyshame`,
  getNurtureRelationship: `${process.env.PUBLIC_URL}/${seeker}/nurture-relationships`,
  getFrenzcoinS: `${process.env.PUBLIC_URL}/${seeker}/frenzcoin`,
  findAJob: `${process.env.PUBLIC_URL}/${seeker}/find-a-job`,
  shareAJob: `${process.env.PUBLIC_URL}/${seeker}/share-a-job`,
  getJourney: `${process.env.PUBLIC_URL}/${seeker}/journey`,
  getFeedback: `${process.env.PUBLIC_URL}/${seeker}/my-feedback`,
  journeySoFar: `${process.env.PUBLIC_URL}/${seeker}/journey-so-far`,
  getHeartbreak: `${process.env.PUBLIC_URL}/${seeker}/heartbreak`,
  getBurnout : `${process.env.PUBLIC_URL}/${seeker}/burnout`,
  getFaliure : `${process.env.PUBLIC_URL}/${seeker}/failure`,
  getIkigai: `${process.env.PUBLIC_URL}/${seeker}/ikigai`,
};

export const giverRoutes = {
  // branch = shubham
  getPersonalisation: `${process.env.PUBLIC_URL}/${giver}/personalisation`,
  getProfile: `${process.env.PUBLIC_URL}/${giver}/profile-g`,
  getProgress: `${process.env.PUBLIC_URL}/${giver}/progress-g`,
  getSubmission: `${process.env.PUBLIC_URL}/${giver}/submission-g`,
  getTransaction: `${process.env.PUBLIC_URL}/${giver}/transaction-g`,
  getReferal: `${process.env.PUBLIC_URL}/${giver}/referal-g`,
  getOneToOne: `${process.env.PUBLIC_URL}/${giver}/one-on-one-g`,
  getWorkShop: `${process.env.PUBLIC_URL}/${giver}/workshop-g`,
  getInspiration: `${process.env.PUBLIC_URL}/${giver}/inspiration-g`,
  getFrenzcoinG: `${process.env.PUBLIC_URL}/${giver}/frenzcoin`,

  becomeaGiver: `${process.env.PUBLIC_URL}/${giver}/become-a-giver`,
  viewMyPage: `${process.env.PUBLIC_URL}/${giver}/view-my-page`,
  editMyPage: `${process.env.PUBLIC_URL}/${giver}/edit-my-page`,
  modifyServices: `${process.env.PUBLIC_URL}/${giver}/modify-services`,
  msFree: `${process.env.PUBLIC_URL}/${giver}/ms-free`,
  msPaid: `${process.env.PUBLIC_URL}/${giver}/ms-paid`,
  oneOnOne: `${process.env.PUBLIC_URL}/${giver}/one-on-one`,
  community: `${process.env.PUBLIC_URL}/${giver}/community`,
  becomeAnEvangelist: `${process.env.PUBLIC_URL}/${giver}/become-an-evangelist`,
  sessionFeedback: `${process.env.PUBLIC_URL}/${giver}/session-feedback`,
  journeySoFar: `${process.env.PUBLIC_URL}/${giver}/journey-so-far`,
};
